import React from 'react';
import serviceTerritory from './service_territory.json';
import { FeatureCollection } from 'geojson';
import { Layer, Source } from 'react-map-gl';
import mainColors from '../../../../themes/main-colors';
import {
  MapType,
  useOutageMapOptions,
} from '../../providers/OutageMapOptionsProvider';

export const PGEServiceTerritory = () => {
  const { mapStyle } = useOutageMapOptions();

  const serviceBoundaryGeoJSON: FeatureCollection = {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        geometry: {
          type: 'MultiPolygon',
          coordinates: serviceTerritory.coordinates,
        },
        properties: {
          name: 'PGE Service Territory',
        },
      },
    ],
  };

  return (
    <Source id="my-geojson" type="geojson" data={serviceBoundaryGeoJSON}>
      <Layer
        id="polygon-layer"
        type="line"
        paint={{
          'line-color':
            mapStyle === MapType.STANDARD || mapStyle === MapType.MONOCHROME
              ? mainColors.rhinoBlack
              : mainColors.black,
          'line-width': 2,
          'line-opacity':
            mapStyle === MapType.STANDARD || mapStyle === MapType.MONOCHROME
              ? 1
              : 0.5,
        }}
      />
    </Source>
  );
};
